import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const questionsForMe = async (reqBody) => {
  const token = await getFromEncLocalStorage("token");

  const data = await invokeApi(endPoints.questionsForMeApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: reqBody,
  });
  return data;
};

const QuestionsForMeService = { questionsForMe };
export default QuestionsForMeService;
